module.exports = __webpack_public_path__ + "img/phone.63b9cf8a.svg";